<template>
  <div id="summary" class="card card-body">
    <div class="row align-items-center">
      <div class="summary__image-column col-4">
        <div class="position-relative ratio ratio-1x1 border-radius-lg overflow-hidden">
          <template v-if="profilePicture || profilePictureData">
            <img :alt="companyName" class="summary-visual__image" :src="profilePicture || profilePictureData" />

            <button class="summary-visual-remove position-absolute top-0 start-0 bottom-0 p-0 border-0
                     w-100 bg-transparent" @click="removeProfilePicture">
              <div class="summary-visual-remove__background w-100 h-100 bg-danger" />

              <i class="position-absolute top-0 start-0 bottom-0 end-0 d-flex justify-content-center
                       align-items-center material-icons text-light fs-2">
                delete_outline
              </i>
            </button>
          </template>

          <label v-else class="d-flex justify-content-center align-items-center w-100 h-100 m-0 bg-gradient-dark
                   cursor-pointer" for="profilePictureData">
            <i class="d-block material-icons text-secondary fs-2">
              add_a_photo
            </i>

            <input id="profilePictureData" accept="image/*" capture="user" class="d-none" type="file"
              @change="profilePictureChanged" />
          </label>
        </div>
      </div>
      <div class="summary__company-name-column col-8">
        <h5>{{ companyName }}</h5>
        <material-checkbox v-model="isVisible" class="mt-2">
          Zichtbaar in app?
        </material-checkbox>
      </div>

    </div>
  </div>
</template>

<script>
import { parseDateTimeRange } from '@/helpers/parsers';

import MaterialCheckbox from '@/components/MaterialCheckbox.vue';

export default {
  name: 'CompanySummary',

  components: {
    MaterialCheckbox,
  },

  props: {
    companyName: {
      type: String,
      required: true,
    },

    profilePicture: {
      type: String,
      required: true,
    },
    profilePictureData: {
      type: String,
      default: '',
    },

    isAppVisible: {
      type: Boolean,
      required: true,
    },
  },

  emits: [
    'update:profilePicture',
    'update:profilePictureData',
    'update:isAppVisible',
  ],

  computed: {
    isVisible: {
      get() {
        return this.isAppVisible;
      },
      set(value) {
        this.$emit('update:isAppVisible', value);
      }
    }
  },

  methods: {
    parseDateTimeRange,

    profilePictureChanged({ target }) {
      const reader = new FileReader();
      reader.onload = ({ target }) => {
        this.$emit('update:profilePictureData', target.result);
      };
      reader.readAsDataURL(target.files[0]);
    },

    removeProfilePicture() {
      if (!confirm('Weet je zeker dat je de afbeelding wil verwijderen?')) {
        return;
      }

      this.$emit('update:profilePicture', '');
      this.$emit('update:profilePictureData', '');
    },
  },
};
</script>

<style scoped lang="scss">
.summary {
  &__image {

    &-column {
      width: 120px;
    }
  }
}

.summary-visual {

  &__image {
    aspect-ratio: 1;
    object-fit: cover;
  }

  &-remove {
    transition: opacity .2s;

    &:not(:hover) {
      opacity: 0;
    }

    &__background {
      opacity: .75;
    }
  }
}

.user-selector-dropdown {
  float: right;
  width: 250px;

  .user-profile-image {
    margin-left: -3px;
    width: 100px;
  }
}
</style>
